<template>
  <v-dialog v-model="dialog" scrollable max-width="800px" persistent>
    <v-card class="primary-card">
      <v-card-title>Finalizar Pedido</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field :value="user.name" readonly variant="outlined"></v-text-field>
            </v-col>
            <v-col cols="4" class="pt-0 pb-1"><v-text-field label="Centro de Custo" v-model="order.cc"
                variant="outlined" :rules="[getRules.required]"></v-text-field>
            </v-col>
            <v-col cols="8" class="pt-0 pb-1">
              <v-text-field :value="user.email" readonly variant="outlined"></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-textarea label="Observações" v-model="order.observation" variant="outlined"></v-textarea>
            </v-col>
            <v-col cols="12" class="px-2">
              <v-card border>
                <v-card-subtitle class="pt-2">Produtos</v-card-subtitle>
                <v-card-text>
                  <v-data-table :items="getOrderProducts" :headers="headers" style="overflow-y: auto!important;" height="250px" items-per-page="-1"
                    hide-default-footer>
                    <template v-slot:item.price="{ item }">
                      <span>R$ {{ fixValue(item.price) }}</span>
                    </template>
                    <template v-slot:item.total="{ item }">
                      <span>R$ {{ getTotalValue(item.price, item.amount) }}</span>
                    </template>
                    <template v-slot:item.amount="{ item }">
                      <!-- <span class="mx-2">{{ item.amount }}</span> -->
                      <v-text-field v-model="item.amount" type="number" class="mx-2 mt-2 text-center" density="compact"
                        variant="outlined" hide-spin-buttons min="1">
                        <template v-slot:append>
                          <v-btn icon="mdi-plus" @click="increaseProductAmount(item)" variant="text"
                            density="compact"></v-btn>
                        </template>
                        <template v-slot:prepend>
                          <v-btn icon="mdi-minus" @click="decreaseProductAmount(item)" variant="text"
                            density="compact"></v-btn>
                        </template>
                      </v-text-field>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon="mdi-delete" @click="removeProduct(item)" variant="text" density="compact"></v-btn>
                    </template>
                    <template v-slot:no-data>
                      <v-alert type="info" class="text-center">
                        Nenhum produto adicionado ao pedido.
                      </v-alert>
                    </template>
                  </v-data-table>
                  <span>
                    <strong>Total: </strong>
                    R$ {{getOrderProducts.reduce((total, item) => total + parseFloat(item.price) * item.amount,
                      0).toFixed(2).replace('.', ',')}}
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">Fechar</v-btn>
        <v-btn color="success" @click="sendOrder">Finalizar Pedido</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: 'OrderDialog',
  data() {
    return {
      dialog: false,
      order: {
        cc: '',
        observation: '',
      },
      headers: [
        { title: 'Produto', value: 'name' },
        { title: 'Quantidade', value: 'amount', align: 'center', width: '190px' },
        { title: 'Preço Unitário', value: 'price' },
        { title: 'Total', value: 'total' },
        { title: 'Ações', value: 'actions', sortable: false, width: '50px' },
      ],
    }
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    open() {      
      this.dialog = true;
    },
    close() {
      this.order = {
        cc: '',
        observation: '',
      };
      this.dialog = false;
    },
    getTotalValue(price, amount) {
      try{
        return (parseFloat(price) * amount).toFixed(2).replace('.', ',');
      } catch (error) {        
        return '0,00';
      }
    },
    fixValue(value) {
      return parseFloat(value).toFixed(2).replace('.', ',');
    },
    removeProduct(item) {
      this.$store.dispatch('removeProduct', item);
    },
    increaseProductAmount(item) {
      this.$store.dispatch('increaseProductAmount', item);
    },
    decreaseProductAmount(item) {
      this.$store.dispatch('decreaseProductAmount', item);
    },
    async sendOrder() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;

      const products = [];
      for (const product in this.$store.getters.getOrderProducts) {
        let prod = this.$store.getters.getOrderProducts[product];
        if (prod.amount <= 0) {
          this.$store.dispatch('showErrorSnack', 'Quantidade de produtos deve ser maior que zero.');
          return;
        }

        products.push({
          id: prod.id,
          name: prod.name,
          price: prod.price,
          amount: prod.amount,
        });
      }

      const orderData = {
        ...this.order,
        userId: this.user.id,
        products: products,
      };      

      this.$http.post('/order', orderData)
        .then(() => {
          this.$store.dispatch('clearOrder');
          this.close();
          this.$store.dispatch('showSuccessSnack', 'Pedido enviado com sucesso!');
        })
        .catch(error => {
          console.error('Erro ao enviar pedido:', error);
          this.$store.dispatch('showErrorSnack', 'Erro ao enviar pedido. Tente novamente.');
        });
    },
  },
  computed: {
    ...mapGetters(['getOrderProducts', 'getRules']),
  },
  watch: {

  },
  mounted() {

  },
  created() {

  },
  unmounted() {

  }
}
</script>

<style scoped></style>